import { Container, Button } from 'react-bootstrap';
import { IoSearchOutline } from 'react-icons/io5';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Config from '../config/Config';
import SectionWrapper from '../components/SectionWrapper';

const DppNotFoundPage = ({ query }) => {
  const { mainColor } = Config.appearance;
  const intl = useIntl();

  return (
    <Container className="my-5">
      <SectionWrapper>
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ padding: '30px' }}>
          
          <h2 className="fw-bold">{intl.formatMessage({ id: 'dpp_not_found' })}</h2>
          <p className="fs-5 mt-2 text-center text-muted">
            {intl.formatMessage({ id: 'dpp_not_found_message' }, { query: <strong>{query}</strong> })}
          </p>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Button
              variant="primary"
              className="mt-3"
              style={{
                height: '55px',
                borderRadius: '10px',
                backgroundColor: mainColor,
                border: 'none',
                width: 'auto',
                minWidth: '65px',
              }}
            >
              {intl.formatMessage({ id: 'back_to_home' })}
            </Button>
          </Link>
        </div>
      </SectionWrapper>
    </Container>
  );
};

export default DppNotFoundPage;
